// extracted by mini-css-extract-plugin
module.exports = {"ad-banner":"L2bgsEcrZV9-_KfjAmqga","scroll-icon":"_1kTFHTuDuTYOBSa7QXJtrx","ad-banner-gif":"_2MYQdORczo44uGGsM9KY05"};